import { Box, Button, Modal, Paper, Typography } from '@mui/material';
import { FC } from 'react';
import SuccessCircle from '~/components/SVG/SuccessCircle.svg?react';
import { styles } from './styles.ts';

interface IModalSuccessProps {
  isOpen: boolean;
  text: string | null;
  buttonValue?: string;
  onClick?: () => void;
  onClose: () => void;
  showButton?: boolean;
  dataTestId?: string;
}

const SuccessModal: FC<IModalSuccessProps> = ({
  isOpen,
  text,
  buttonValue,
  onClick,
  onClose,
  showButton = true,
  dataTestId,
}) => {
  if (!isOpen) return null;

  const handleButtonClick = (): void => {
    if (onClick) {
      onClick();
    } else {
      onClose();
    }
  };

  const handleModalClose = (_event: object, reason: 'backdropClick' | 'escapeKeyDown'): void => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }

    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleModalClose}
      disableEscapeKeyDown
      sx={styles.modal}
      slotProps={{ backdrop: { sx: styles.backdrop } }}
    >
      <Paper sx={styles.paper} data-testid={dataTestId}>
        <Box sx={styles.content}>
          <Box sx={styles.icon}>
            <SuccessCircle aria-label="Success icon" />
          </Box>
          <Typography sx={styles.text}>{text}</Typography>
        </Box>
        {showButton && (
          <Box sx={styles.actions}>
            <Button variant="contained" size="large" onClick={handleButtonClick}>
              {buttonValue}
            </Button>
          </Box>
        )}
      </Paper>
    </Modal>
  );
};

export default SuccessModal;
